import { useParams } from 'react-router-dom';
import { useFutebolRealtime } from '../hooks/useFutebolRealtime';
import { useProximoJogo } from '../hooks/useProximoJogo';
import { usePlayerConfig } from '@/features/player';
import { resolverEstadoJogoMobile } from '../../domain/usecases/partida';
import { MobilePreGameVoting } from '@/features/futebol-votacao';
import { TelaCarregando } from '../components/jogo/JogoSharedCards';
import { JogoIdleHub } from '../components/jogo/JogoIdleHub';
import { JogoPreJogoView } from '../components/jogo/JogoPreJogoView';
import { JogoAoVivoTabs } from '../components/jogo/JogoAoVivoTabs';
import { JogoEncerradoView } from '../components/jogo/JogoEncerradoView';
import { JogoHistoricoDia } from '../components/jogo/JogoHistoricoDia';

/**
 * Arquibancada — hub mobile de futebol (placar, Termômetro, Bolão).
 * Âncora: placar com cue “No ar” quando a bola rola.
 */
export default function JogoAoVivoPage() {
  const { telaId } = useParams<{ telaId: string }>();
  const id = telaId ?? '';
  const { partida, jogo, loading } = useFutebolRealtime(id);
  const estado = resolverEstadoJogoMobile(partida);
  const proximoJogo = useProximoJogo(estado === 'idle');
  const [playerConfig] = usePlayerConfig(telaId);
  const exibirBolao = playerConfig.exibir_bolao;

  const aoVivo = estado === 'ao_vivo';

  return (
    <div className="flex min-h-[100dvh] flex-col bg-jukebox-bg pb-24">
      <header className="shrink-0 border-b border-white/[0.05] px-4 py-3 [padding-top:calc(0.75rem+env(safe-area-inset-top))]">
        <p className="text-center text-[11px] font-medium text-white/30">Salão · Arquibancada</p>
        <div className="mt-0.5 flex items-center justify-center gap-2">
          <h1 className="text-sm font-bold tracking-tight text-white">Jogo</h1>
          {aoVivo && (
            <span className="inline-flex items-center gap-1.5 rounded-md bg-rose-500/15 px-1.5 py-0.5 text-[10px] font-bold text-rose-400 ring-1 ring-rose-500/30">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-rose-400" />
              No ar
            </span>
          )}
        </div>
      </header>

      <div className="shrink-0 px-4 pt-4">
        <MobilePreGameVoting telaId={id} />
      </div>

      {loading ? (
        <TelaCarregando />
      ) : estado === 'idle' ? (
        <JogoIdleHub proximoJogo={proximoJogo} />
      ) : estado === 'pre_jogo' && partida ? (
        <JogoPreJogoView telaId={id} partida={partida} jogo={jogo} exibirBolao={exibirBolao} />
      ) : estado === 'ao_vivo' && partida ? (
        <JogoAoVivoTabs telaId={id} partida={partida} jogo={jogo} exibirBolao={exibirBolao} />
      ) : estado === 'encerrado' && partida ? (
        <JogoEncerradoView telaId={id} partida={partida} jogo={jogo} exibirBolao={exibirBolao} />
      ) : null}

      {!loading && (
        <JogoHistoricoDia
          telaId={id}
          partidaAtual={partida}
          jogoAtual={jogo}
          exibirBolao={exibirBolao}
          excludeFixtureId={estado === 'encerrado' ? partida?.fixture_id ?? null : null}
        />
      )}
    </div>
  );
}
